export const JavaScript = "JavaScript";
export const TypeScript = "TypeScript";
export const Angular = "Angular 2+";
export const ReactJs = "ReactJs";
export const SASS = "SASS";
export const HTML = "HTML";
export const CSS = "CSS";
export const jQuery = "jQuery";
export const p5 = "p5";
export const PWA_APPS = "PWA APPS";
export const Ionic = "Ionic";
export const Redux = "Redux";
export const NodeJS = "NodeJS";
export const Heroku_hosting = "Heroku hosting";
export const Firebase_DB_andnotifications = "Firebase";
export const CleanCode = "Clean Code";
export const ReactApollo = "React Apollo";
export const Git = "Git";
export const GraphQl = "GraphQl";
